import styled, { css } from 'styled-components'


const topBunTrans = 'rotate(-45deg) translate(-9px, 6px)';
const bottomBunTrans = 'rotate(45deg) translate(-8px, -8px)';

export const AnimatedHamburgerButtonStyled = styled.div<{ isBurger: boolean, disabled: boolean }>`

height: 46px;
width: 50px;

border-radius: 8px;
background-color: #00000020;

${({ disabled }) => disabled ? css`
  pointer-events: none;
  opacity: 50%;
` : ''}

:hover {
  background-color: #80808080;
  cursor: pointer;
}

> div {
  margin: 3px 8px;
  display: inline-block;
}

.AHBTopBun, .AHBPatty, .AHBBottomBun {
  width: 35px;
  height: 5px;
  background-color: white;
  margin: 6px 0;
  border-radius: 2px;
}

${({ isBurger }) => isBurger ? '' : css`
  /* Rotate first bar */
  .AHBTopBun {
    -webkit-transform: ${topBunTrans};
    transform: ${topBunTrans};
  }

  /* Fade out the second bar */
  .AHBPatty {
    opacity: 0;
  }

  /* Rotate last bar */
  .AHBBottomBun {
    -webkit-transform: ${bottomBunTrans};
    transform: ${bottomBunTrans};
  }
`}

`;